module.exports = __webpack_public_path__ + "static/media/sunflower-top-corner.17e257ca.png";